const P2POrg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="744"
    height="744"
    fill="none"
    viewBox="0 0 744 744"
  >
    <path fill="#136BFF" d="M0 0H744V744H0z"></path>
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M110 318a2 2 0 00-2 2v60a2 2 0 002 2h156a2 2 0 002-2v-60a2 2 0 00-2-2H110zm137 44a1 1 0 001-1v-22a1 1 0 00-1-1H129a1 1 0 00-1 1v22a1 1 0 001 1h118z"
      clipRule="evenodd"
    ></path>
    <path
      fill="#fff"
      d="M128 408a2 2 0 00-2-2h-16a2 2 0 00-2 2v16a2 2 0 002 2h16a2 2 0 002-2v-16zM496 408a2 2 0 00-2-2h-16a2 2 0 00-2 2v16a2 2 0 002 2h16a2 2 0 002-2v-16zM292 408a2 2 0 012-2h156a2 2 0 012 2v16a2 2 0 01-2 2H294a2 2 0 01-2-2v-16z"
    ></path>
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M476 320a2 2 0 012-2h156a2 2 0 012 2v60a2 2 0 01-2 2H478a2 2 0 01-2-2v-60zm139 18a1 1 0 011 1v22a1 1 0 01-1 1H497a1 1 0 01-1-1v-22a1 1 0 011-1h118z"
      clipRule="evenodd"
    ></path>
    <path
      fill="#fff"
      d="M294 318a2 2 0 00-2 2v16a2 2 0 002 2h137a1 1 0 011 1v22a1 1 0 01-1 1H294a2 2 0 00-2 2v16a2 2 0 002 2h156a2 2 0 002-2v-60a2 2 0 00-2-2H294z"
    ></path>
  </svg>
);

export default P2POrg;
